var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "p-20" },
    [
      _c(
        "van-form",
        {
          ref: "form",
          attrs: { "show-error": false, "error-message-align": "right" },
        },
        [
          _c(
            "van-cell-group",
            [
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "flowNo",
                    expression: "'flowNo'",
                  },
                ],
                attrs: {
                  required: _vm.isRequired("flowNo"),
                  rules: _vm.getRules("flowNo"),
                  label: "编号",
                  "input-align": "right",
                  readonly: "",
                },
                model: {
                  value: _vm.formData.flowNo,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "flowNo", $$v)
                  },
                  expression: "formData.flowNo",
                },
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "ssbm",
                    expression: "'ssbm'",
                  },
                ],
                attrs: {
                  "input-align": "right",
                  name: "ssbm",
                  required: _vm.isRequired("ssbm"),
                  value: _vm.formData.ssbm,
                  label: "部门",
                  rules: _vm.getRules("ssbm"),
                  placeholder: "请选择部门",
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("view-item", {
                          attrs: {
                            value: _vm.formData.ssbm,
                            placeholder: "请选择部门",
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.isShowPopup(_vm.ssbm, "ssbm")
                            },
                          },
                        }),
                        _c(
                          "van-popup",
                          {
                            attrs: { position: "bottom" },
                            model: {
                              value: _vm.ssbm.show,
                              callback: function ($$v) {
                                _vm.$set(_vm.ssbm, "show", $$v)
                              },
                              expression: "ssbm.show",
                            },
                          },
                          [
                            _c("van-nav-bar", {
                              attrs: {
                                title: "选择部门",
                                "left-text": "取消",
                                "right-text": "确定",
                              },
                              on: {
                                "click-left": function ($event) {
                                  _vm.ssbm.show = false
                                },
                                "click-right": function ($event) {
                                  return _vm.popupSubmit("ssbm", {
                                    label: "label",
                                    value: "value",
                                  })
                                },
                              },
                            }),
                            _c("van-search", {
                              attrs: { clearable: "", shape: "round" },
                              on: {
                                input: function ($event) {
                                  return _vm.pickerSearch(
                                    $event,
                                    _vm.ssbm,
                                    "label"
                                  )
                                },
                              },
                              model: {
                                value: _vm.ssbm.filterText,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ssbm, "filterText", $$v)
                                },
                                expression: "ssbm.filterText",
                              },
                            }),
                            _c("van-picker", {
                              ref: "ssbm",
                              attrs: {
                                "value-key": "label",
                                columns: _vm.ssbm.filteredData,
                              },
                              on: {
                                cancel: function ($event) {
                                  _vm.ssbm.show = false
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "sy",
                    expression: "'sy'",
                  },
                ],
                attrs: {
                  readonly: _vm.isDisabled("sy"),
                  required: _vm.isRequired("sy"),
                  name: "sy",
                  rules: _vm.getRules("sy"),
                  type: "textarea",
                  maxlength: "200",
                  rows: "3",
                  autosize: "",
                  label: "出差事由",
                  "show-word-limit": "",
                  placeholder: "请输入出差事由",
                  "input-align": "right",
                },
                model: {
                  value: _vm.formData.sy,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "sy", $$v)
                  },
                  expression: "formData.sy",
                },
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "ccsj",
                    expression: "'ccsj'",
                  },
                ],
                attrs: {
                  value: _vm.formData.ccsj[0],
                  required: _vm.isRequired("ccsj"),
                  name: "ccsj",
                  label: "出差时间",
                  placeholder: "出差时间",
                  "input-align": "right",
                  rules: _vm.getRules("ccsj"),
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("view-item", {
                          attrs: {
                            value:
                              _vm.formData.ccsj.length > 1
                                ? `${_vm.formData.ccsj[0]} - ${_vm.formData.ccsj[1]}`
                                : "",
                            placeholder: "请选择出差时间",
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.isShowPopup(_vm.ccsj, "ccsj")
                            },
                          },
                        }),
                        _c("van-calendar", {
                          ref: "ccsj",
                          attrs: {
                            "min-date": new Date(2010, 1, 1),
                            "allow-same-day": "",
                            type: "range",
                            "show-confirm": false,
                            title: "选择出差时间",
                          },
                          on: { confirm: _vm.ccsjConfirm },
                          model: {
                            value: _vm.ccsj.show,
                            callback: function ($$v) {
                              _vm.$set(_vm.ccsj, "show", $$v)
                            },
                            expression: "ccsj.show",
                          },
                        }),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "ccts",
                    expression: "'ccts'",
                  },
                ],
                attrs: {
                  disabled: _vm.isDisabled("ccts"),
                  type: "number",
                  name: "ccts",
                  rules: _vm.getRules("ccts"),
                  required: _vm.isRequired("ccts"),
                  maxlength: 8,
                  placeholder: "请输入出差天数",
                  label: "出差天数",
                  "input-align": "right",
                },
                model: {
                  value: _vm.formData.ccts,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "ccts", $$v)
                  },
                  expression: "formData.ccts",
                },
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "fj",
                    expression: "'fj'",
                  },
                ],
                staticClass: "fileValueBox",
                attrs: {
                  "input-align": "right",
                  name: "fj",
                  required: _vm.isRequired("fj"),
                  rules: _vm.getRules("fj"),
                  label: "附件",
                  placeholder: "请上传文件",
                },
                domProps: { value: _vm.formData.fj },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("uploadFiles", {
                          attrs: {
                            disabled: _vm.isDisabled("fj"),
                            files: _vm.formData.fj,
                            "module-type": "flow",
                          },
                          on: {
                            success: _vm.uploadSuccess,
                            fileRemove: (removedFile) =>
                              _vm.handleFileRemove(
                                removedFile,
                                "formData",
                                "fj"
                              ),
                          },
                        }),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
            ],
            1
          ),
          _c("div", { staticStyle: { display: "flex" } }, [
            _c(
              "div",
              { staticClass: "font-32 font-weight-500 cor-00 m-t-26 m-b-26" },
              [_vm._v(" 出差明细 ")]
            ),
            _c(
              "div",
              { staticClass: "width-80 m-t-10" },
              [
                _c(
                  "van-notice-bar",
                  {
                    attrs: {
                      color: "#ed6a0c",
                      background: "rgb(247,247,247)",
                      "left-icon": "info-o",
                    },
                    on: { click: _vm.tripDetail },
                  },
                  [_vm._v(" 请确保您的出差行程形成一个完... ")]
                ),
              ],
              1
            ),
          ]),
          _vm._l(_vm.formData.ccmxb, function (item, index) {
            return _c(
              "van-cell-group",
              { key: index, staticClass: "b-r-10 m-t-20" },
              [
                _c(
                  "div",
                  {
                    staticClass: "p-b-20",
                    staticStyle: { "border-bottom": "1px solid #EBEBEB" },
                  },
                  [
                    _c(
                      "van-row",
                      { attrs: { type: "flex", align: "center" } },
                      [
                        _c("van-col", { attrs: { span: 22 } }, [
                          _c("img", {
                            staticClass: "w-5 h-28",
                            attrs: {
                              src: `${_vm.image_base_url}/icon_line.png`,
                            },
                          }),
                          _c(
                            "span",
                            {
                              staticClass:
                                "cor-33 font-weight-500 font-28 m-l-16",
                            },
                            [_vm._v(_vm._s(`明细${index + 1}`))]
                          ),
                        ]),
                        _vm.isShowIcon("ccmxb")
                          ? _c(
                              "van-col",
                              {
                                attrs: { span: 2 },
                                on: {
                                  click: function ($event) {
                                    return _vm.removeItem(index, "ccmxb")
                                  },
                                },
                              },
                              [
                                _c("img", {
                                  staticClass: "w-30 h-30",
                                  attrs: {
                                    src: `${_vm.image_base_url}/shoppingDel.png`,
                                  },
                                }),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("van-field", {
                  directives: [
                    {
                      name: "f-show",
                      rawName: "v-f-show",
                      value: "xch",
                      expression: "'xch'",
                    },
                  ],
                  attrs: {
                    required: _vm.isRequired("xch"),
                    value: item.xch,
                    rules: _vm.getRules("xch"),
                    label: "行程号",
                    "input-align": "right",
                    readonly: "",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "input",
                        fn: function () {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  (item.xch =
                                    _vm.formData.flowNo + "_" + (index + 1))
                                ) +
                                " "
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    true
                  ),
                }),
                _c("van-field", {
                  directives: [
                    {
                      name: "f-show",
                      rawName: "v-f-show",
                      value: "cfsj",
                      expression: "'cfsj'",
                    },
                  ],
                  attrs: {
                    required: _vm.isRequired("cfsj"),
                    name: "cfsj",
                    label: "出发时间",
                    placeholder: "出发时间",
                    "input-align": "right",
                    rules: _vm.getRules("cfsj"),
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "input",
                        fn: function () {
                          return [
                            _c("view-item", {
                              attrs: {
                                value: item.cfsj,
                                placeholder: "请选择出发时间",
                              },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.popupShow(
                                    _vm.cfsj.show,
                                    index,
                                    "cfsj"
                                  )
                                },
                              },
                            }),
                            _c("van-calendar", {
                              ref: "cfsj",
                              refInFor: true,
                              attrs: {
                                "min-date": new Date(2010, 1, 1),
                                "show-confirm": false,
                                title: "选择出发时间",
                              },
                              on: {
                                confirm: (date) => {
                                  _vm.cfsjConfirm(date, item, index)
                                },
                              },
                              model: {
                                value: _vm.cfsj.show[index],
                                callback: function ($$v) {
                                  _vm.$set(_vm.cfsj.show, index, $$v)
                                },
                                expression: "cfsj.show[index]",
                              },
                            }),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    true
                  ),
                  model: {
                    value: item.cfsj,
                    callback: function ($$v) {
                      _vm.$set(item, "cfsj", $$v)
                    },
                    expression: "item.cfsj",
                  },
                }),
                _c("van-field", {
                  directives: [
                    {
                      name: "f-show",
                      rawName: "v-f-show",
                      value: "fromCity",
                      expression: "'fromCity'",
                    },
                  ],
                  attrs: {
                    name: "fromCity",
                    required: _vm.isRequired("fromCity"),
                    rules: _vm.getRules("fromCity"),
                    label: "出发城市",
                    placeholder: "出发城市",
                    "input-align": "right",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "input",
                        fn: function () {
                          return [
                            _c("view-item", {
                              attrs: {
                                value: item.fromCity,
                                placeholder: "请选择出发城市",
                              },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.popupShow(
                                    _vm.fromCity.show,
                                    index,
                                    "fromCity"
                                  )
                                },
                              },
                            }),
                            _c(
                              "van-popup",
                              {
                                attrs: { position: "bottom" },
                                model: {
                                  value: _vm.fromCity.show[index],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.fromCity.show, index, $$v)
                                  },
                                  expression: "fromCity.show[index]",
                                },
                              },
                              [
                                _c("van-nav-bar", {
                                  attrs: {
                                    title: "选择出发城市",
                                    "left-text": "取消",
                                    "right-text": "确定",
                                  },
                                  on: {
                                    "click-left": function ($event) {
                                      return _vm.popupHidden(
                                        _vm.fromCity.show,
                                        index
                                      )
                                    },
                                    "click-right": function ($event) {
                                      return _vm.fromCityPopupSubmit(
                                        item,
                                        index
                                      )
                                    },
                                  },
                                }),
                                _c("van-search", {
                                  attrs: { clearable: "", shape: "round" },
                                  on: {
                                    input: function ($event) {
                                      return _vm.treeSearch(
                                        $event,
                                        _vm.$refs[`fromCityTree_${index}`]
                                      )
                                    },
                                  },
                                  model: {
                                    value: _vm.fromCity.filterText[index],
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.fromCity.filterText,
                                        index,
                                        $$v
                                      )
                                    },
                                    expression: "fromCity.filterText[index]",
                                  },
                                }),
                                _c(
                                  "div",
                                  {
                                    staticClass: "h-vh-35",
                                    staticStyle: { "overflow-y": "auto" },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "p-10" },
                                      [
                                        _c("el-tree", {
                                          ref: `fromCityTree_${index}`,
                                          refInFor: true,
                                          attrs: {
                                            "node-key": "id",
                                            "check-strictly": "",
                                            data: _vm.fromCity.data,
                                            "filter-node-method":
                                              _vm.filterNode,
                                            "check-on-click-node": "",
                                            "show-checkbox": "",
                                          },
                                          on: {
                                            "check-change": function ($event) {
                                              return _vm.singleChoice(
                                                $event,
                                                _vm.$refs[
                                                  `fromCityTree_${index}`
                                                ],
                                                index
                                              )
                                            },
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    true
                  ),
                  model: {
                    value: item.fromCity,
                    callback: function ($$v) {
                      _vm.$set(item, "fromCity", $$v)
                    },
                    expression: "item.fromCity",
                  },
                }),
                _c("van-field", {
                  directives: [
                    {
                      name: "f-show",
                      rawName: "v-f-show",
                      value: "toCity",
                      expression: "'toCity'",
                    },
                  ],
                  attrs: {
                    name: "toCity",
                    required: _vm.isRequired("toCity"),
                    rules: _vm.getRules("toCity"),
                    label: "到达城市",
                    placeholder: "到达城市",
                    "input-align": "right",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "input",
                        fn: function () {
                          return [
                            _c("view-item", {
                              attrs: {
                                value: item.toCity,
                                placeholder: "请选择到达城市",
                              },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.popupShow(
                                    _vm.toCity.show,
                                    index,
                                    "toCity"
                                  )
                                },
                              },
                            }),
                            _c(
                              "van-popup",
                              {
                                attrs: { position: "bottom" },
                                model: {
                                  value: _vm.toCity.show[index],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.toCity.show, index, $$v)
                                  },
                                  expression: "toCity.show[index]",
                                },
                              },
                              [
                                _c("van-nav-bar", {
                                  attrs: {
                                    title: "选择到达城市",
                                    "left-text": "取消",
                                    "right-text": "确定",
                                  },
                                  on: {
                                    "click-left": function ($event) {
                                      return _vm.popupHidden(
                                        _vm.toCity.show,
                                        index
                                      )
                                    },
                                    "click-right": function ($event) {
                                      return _vm.toCityPopupSubmit(item, index)
                                    },
                                  },
                                }),
                                _c("van-search", {
                                  attrs: { clearable: "", shape: "round" },
                                  on: {
                                    input: function ($event) {
                                      return _vm.treeSearch(
                                        $event,
                                        _vm.$refs[`toCityTree_${index}`]
                                      )
                                    },
                                  },
                                  model: {
                                    value: _vm.toCity.filterText[index],
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.toCity.filterText,
                                        index,
                                        $$v
                                      )
                                    },
                                    expression: "toCity.filterText[index]",
                                  },
                                }),
                                _c(
                                  "div",
                                  {
                                    staticClass: "h-vh-35",
                                    staticStyle: { "overflow-y": "auto" },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "p-10" },
                                      [
                                        _c("el-tree", {
                                          ref: `toCityTree_${index}`,
                                          refInFor: true,
                                          attrs: {
                                            "node-key": "id",
                                            "check-strictly": "",
                                            data: _vm.toCity.data,
                                            "filter-node-method":
                                              _vm.filterNode,
                                            "check-on-click-node": "",
                                            "show-checkbox": "",
                                          },
                                          on: {
                                            "check-change": function ($event) {
                                              return _vm.singleChoice(
                                                $event,
                                                _vm.$refs[
                                                  `toCityTree_${index}`
                                                ],
                                                index
                                              )
                                            },
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    true
                  ),
                  model: {
                    value: item.toCity,
                    callback: function ($$v) {
                      _vm.$set(item, "toCity", $$v)
                    },
                    expression: "item.toCity",
                  },
                }),
                _c("van-field", {
                  directives: [
                    {
                      name: "f-show",
                      rawName: "v-f-show",
                      value: "sfzs",
                      expression: "'sfzs'",
                    },
                  ],
                  attrs: {
                    "input-align": "right",
                    name: "sfzs",
                    rules: _vm.getRules("sfzs"),
                    required: _vm.isRequired("sfzs"),
                    value: item.sfzs,
                    label: "是否住宿",
                    placeholder: "请选择是否住宿",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "input",
                        fn: function () {
                          return [
                            _c("view-item", {
                              attrs: {
                                value: item.sfzs,
                                placeholder: "请选择是否住宿",
                              },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.popupShow(
                                    _vm.sfzs.show,
                                    index,
                                    "sfzs"
                                  )
                                },
                              },
                            }),
                            _c(
                              "van-popup",
                              {
                                attrs: { position: "bottom" },
                                model: {
                                  value: _vm.sfzs.show[index],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.sfzs.show, index, $$v)
                                  },
                                  expression: "sfzs.show[index]",
                                },
                              },
                              [
                                _c("van-nav-bar", {
                                  attrs: {
                                    title: "选择是否住宿",
                                    "left-text": "取消",
                                    "right-text": "确定",
                                  },
                                  on: {
                                    "click-left": function ($event) {
                                      return _vm.popupHidden(
                                        _vm.sfzs.show,
                                        index
                                      )
                                    },
                                    "click-right": function ($event) {
                                      return _vm.sfzsSubmit(item, index)
                                    },
                                  },
                                }),
                                _c("van-search", {
                                  attrs: { clearable: "", shape: "round" },
                                  on: {
                                    input: function ($event) {
                                      return _vm.pickerSearch($event, _vm.sfzs)
                                    },
                                  },
                                  model: {
                                    value: _vm.sfzs.filterText,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.sfzs, "filterText", $$v)
                                    },
                                    expression: "sfzs.filterText",
                                  },
                                }),
                                _c("van-picker", {
                                  ref: `sfzsPicker_${index}`,
                                  refInFor: true,
                                  attrs: {
                                    "value-key": "name",
                                    columns: _vm.sfzs.filteredData,
                                  },
                                  on: {
                                    cancel: function ($event) {
                                      _vm.sfzs.show = false
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    true
                  ),
                }),
                _c("van-field", {
                  directives: [
                    {
                      name: "f-show",
                      rawName: "v-f-show",
                      value: "jtgj",
                      expression: "'jtgj'",
                    },
                  ],
                  attrs: {
                    "input-align": "right",
                    name: "jtgj",
                    rules: _vm.getRules("jtgj"),
                    required: _vm.isRequired("jtgj"),
                    value: item.jtgj,
                    label: "交通工具",
                    placeholder: "请选择交通工具",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "input",
                        fn: function () {
                          return [
                            _c("view-item", {
                              attrs: {
                                value: item.jtgj,
                                placeholder: "请选择交通工具",
                              },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.popupShow(
                                    _vm.jtgj.show,
                                    index,
                                    "jtgj"
                                  )
                                },
                              },
                            }),
                            _c(
                              "van-popup",
                              {
                                attrs: { position: "bottom" },
                                model: {
                                  value: _vm.jtgj.show[index],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.jtgj.show, index, $$v)
                                  },
                                  expression: "jtgj.show[index]",
                                },
                              },
                              [
                                _c("van-nav-bar", {
                                  attrs: {
                                    title: "选择交通工具",
                                    "left-text": "取消",
                                    "right-text": "确定",
                                  },
                                  on: {
                                    "click-left": function ($event) {
                                      return _vm.popupHidden(
                                        _vm.jtgj.show,
                                        index
                                      )
                                    },
                                    "click-right": function ($event) {
                                      return _vm.jtgjSubmit(item, index)
                                    },
                                  },
                                }),
                                _c("van-search", {
                                  attrs: { clearable: "", shape: "round" },
                                  on: {
                                    input: function ($event) {
                                      return _vm.pickerSearch($event, _vm.jtgj)
                                    },
                                  },
                                  model: {
                                    value: _vm.jtgj.filterText,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.jtgj, "filterText", $$v)
                                    },
                                    expression: "jtgj.filterText",
                                  },
                                }),
                                _c("van-picker", {
                                  ref: `jtgjPicker_${index}`,
                                  refInFor: true,
                                  attrs: {
                                    "value-key": "name",
                                    columns: _vm.jtgj.filteredData,
                                  },
                                  on: {
                                    cancel: function ($event) {
                                      _vm.jtgj.show = false
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    true
                  ),
                }),
                _c("van-field", {
                  directives: [
                    {
                      name: "f-show",
                      rawName: "v-f-show",
                      value: "lksj",
                      expression: "'lksj'",
                    },
                  ],
                  attrs: {
                    required: _vm.isRequired("lksj"),
                    name: "lksj",
                    label: "离开时间",
                    placeholder: "离开时间",
                    "input-align": "right",
                    rules: _vm.getRules("lksj"),
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "input",
                        fn: function () {
                          return [
                            _c("view-item", {
                              attrs: {
                                value: item.lksj,
                                placeholder: "请选择离开时间",
                              },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.popupShow(
                                    _vm.lksj.show,
                                    index,
                                    "lksj"
                                  )
                                },
                              },
                            }),
                            _c("van-calendar", {
                              ref: "lksj",
                              refInFor: true,
                              attrs: {
                                "min-date": new Date(2010, 1, 1),
                                "show-confirm": false,
                                title: "选择离开时间",
                              },
                              on: {
                                confirm: (date) => {
                                  _vm.lksjConfirm(date, item, index)
                                },
                              },
                              model: {
                                value: _vm.lksj.show[index],
                                callback: function ($$v) {
                                  _vm.$set(_vm.lksj.show, index, $$v)
                                },
                                expression: "lksj.show[index]",
                              },
                            }),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    true
                  ),
                  model: {
                    value: item.lksj,
                    callback: function ($$v) {
                      _vm.$set(item, "lksj", $$v)
                    },
                    expression: "item.lksj",
                  },
                }),
              ],
              1
            )
          }),
          !_vm.isDisabled("ccmxb")
            ? _c(
                "van-row",
                [
                  _c("van-col", { attrs: { span: 12 } }),
                  _c(
                    "van-col",
                    { attrs: { span: 12 } },
                    [
                      _c("van-button", {
                        staticClass: "width-100",
                        attrs: {
                          icon: "add-o",
                          round: "",
                          "native-type": "button",
                          color: "#FFDA3E",
                          text: "添加出差明细",
                        },
                        on: { click: _vm.addCcItem },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        2
      ),
      _c("div", { staticClass: "font-32 font-weight-500 cor-00 m-t-26" }, [
        _vm._v("流程"),
      ]),
      !_vm.$route.query.reSend &&
      (_vm.processInstanceId || _vm.$route.query.processInstanceId)
        ? _c("flowTrace", {
            staticClass: "m-t-20",
            attrs: {
              flowTraceList: _vm.flowTrace,
              processInfo: _vm.processData,
            },
          })
        : _c("approver", {
            ref: "approver",
            staticClass: "m-t-20",
            attrs: {
              processData: _vm.processData,
              formData: _vm.formData,
              formItemMap: _vm.formItemMap,
            },
            on: { addUser: _vm.addUser },
          }),
      _c("bottom-bar", { on: { submit: _vm.submit, mention: _vm.mention } }),
      _c(
        "van-popup",
        {
          attrs: { position: "bottom" },
          model: {
            value: _vm.approver.show,
            callback: function ($$v) {
              _vm.$set(_vm.approver, "show", $$v)
            },
            expression: "approver.show",
          },
        },
        [
          _c("van-nav-bar", {
            attrs: {
              title: "选择办理人",
              "left-text": "取消",
              "right-text": "确定",
            },
            on: {
              "click-left": function ($event) {
                _vm.approver.show = false
              },
              "click-right": _vm.approverPopupSubmit,
            },
          }),
          _c("van-search", {
            attrs: { clearable: "", shape: "round" },
            on: {
              input: function ($event) {
                return _vm.treeSearch($event, _vm.$refs.approverTree)
              },
            },
            model: {
              value: _vm.approver.filterText,
              callback: function ($$v) {
                _vm.$set(_vm.approver, "filterText", $$v)
              },
              expression: "approver.filterText",
            },
          }),
          _c(
            "div",
            { staticClass: "h-vh-50", staticStyle: { "overflow-y": "auto" } },
            [
              _c(
                "div",
                { staticClass: "p-10" },
                [
                  _c("el-tree", {
                    ref: "approverTree",
                    attrs: {
                      "node-key": "uuid",
                      "check-strictly": "",
                      data: _vm.approver.data,
                      "filter-node-method": _vm.filterNode,
                      "check-on-click-node": "",
                      "show-checkbox": "",
                    },
                    on: {
                      "check-change": function ($event) {
                        return _vm.approverCheckChange(
                          $event,
                          _vm.$refs.approverTree
                        )
                      },
                    },
                  }),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }